export default __webpack_public_path__ + "static/media/ICOne.c8a121bf.jpg";